<template> 
  <div class="card">
    <div class="up">
      <div id="img-container">
        <div class="img" v-html="img" v-on:click="click(binderId, true)"> </div>
      </div> 
      <input type="checkbox" 
             name="checkbox_binder" 
     v-bind:value="binderId" 
        v-bind:id="'checkbox_binder_'+binderId" 
       v-on:click="click(binderId, false)" 
       v-bind:checked="checked"/>
    </div> 
    <div class="down">
      <div class="div-inline" style=" left:5px"> {{ binderId }} </div> 
      <div class="div-inline" style="right:5px"> {{ warheadName }} </div> 
    </div> 
  </div>
</template> 

<script>
export default {
  name: 'binderCard',
  props: ['img', 'binderId', 'warheadName', 'checked'],
  methods: {
    click: function (binderId, flag) { 
      if (flag==true) {
        var checkbox = document.getElementById('checkbox_binder_'+binderId) 
        checkbox.checked = !checkbox.checked  
      }
      this.$emit('click_checkbox', 'checkbox_binder')
      // console.log(binderId)
    } 
  }  
} 

</script> 
 
<style scoped> 
  .card {
    margin: 1px;
    border: 1px solid black;
    margin-right: 1px;
    height: 230px;
    width:  250px; 
    display: flex;
    flex-direction: column;
  }
  .up { 
    display: flex; 
    justify-content: space-between;
    position: relative;
  }
  #img-container {
    border: 0px solid black;
    width: 250px;
    height:210px;
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: center;
  } 
  input {
    position: absolute;
    left: 105px;
  } 
  img[alt~="Mol"] { 
    border: 0px solid black;
    height:200px; 
    width:200px; 
  } 
  .down {
    position: relative;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
  } 
  input[type="checkbox"] { 
    zoom: 2;
  } 
  .div-inline{
    display:inline-block;
    position: absolute;
  }
</style>
